module.exports = __webpack_public_path__ + "images/sgp/featuredContentImages/cheapest-storage-units-for-rent.webp";